<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-awsMarket',
  components: { PageTable },
}
</script>
